"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeVariants = void 0;
var _styledComponents = require("styled-components");
var _types = require("../types");
var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var typeVariants = (0, _styledComponents.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
  var $type = _a.$type,
    theme = _a.theme;
  switch ($type) {
    case _types.HintTypes.Error:
      return (0, _styledComponents.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                    color: ", ";\n                "], ["\n                    color: ", ";\n                "])), theme.colors.alert.error.text);
    case _types.HintTypes.Warning:
      return (0, _styledComponents.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                    color: ", ";\n                "], ["\n                    color: ", ";\n                "])), theme.colors.alert.warning.text);
    case _types.HintTypes.Success:
      return (0, _styledComponents.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                    color: ", ";\n                "], ["\n                    color: ", ";\n                "])), theme.colors.alert.success.text);
    case _types.HintTypes.Loading:
      return (0, _styledComponents.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                    color: ", ";\n                "], ["\n                    color: ", ";\n                "])), theme.colors.alert.loading.text);
    default:
    case _types.HintTypes.Info:
      return (0, _styledComponents.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                    color: ", ";\n                "], ["\n                    color: ", ";\n                "])), theme.colors.alert.hint.text);
  }
});
exports.typeVariants = typeVariants;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;